export class InventoryUserType {
  name: string = "";
  allowedFormFactors: string[] = [];
  minimumScreenSize: number = 0;
  maximumScreenSize: number = 0;
  minimumStorage: number = 0;
  requiresFingerprintSensor: boolean = false;
  requiresPrivacyScreen: boolean = false;
  requiresBacklitKeyboard: boolean = false;
  requiresStylus: boolean = false;
}
